<template>
  <nav class="custom-navbar">
    <div class="container">
      <!-- Logo或图片占位符 -->
      <div class="navbar-brand">
        <img src="@/assets/img/navbar_logo.png" alt="">
      </div>
      <!-- 导航菜单 -->
      <ul class="navbar-menu">
        <li
          class="navbar-item"
          v-for="(refName, index) in refNameList"
          :key="index"
        >
          <a
            href="javascript:;"
            class="navbar-link"
            :class="refNameIndex == index ? 'navbar-link-active' : ''"
            @click="handleLinkClick(refName, index)"
            >{{ navbarNameList[index] }}</a
          >
        </li>
        <!-- <li class="navbar-item">
          <a href="#" class="navbar-link" @click="handleLinkClick('sectionProducts')">产品服务</a>
        </li>
        <li class="navbar-item">
          <a href="#" class="navbar-link">招商加盟</a>
        </li>
        <li class="navbar-item">
          <a href="#" class="navbar-link">新闻动态</a>
        </li>
        <li class="navbar-item">
          <a href="#" class="navbar-link">了解我们</a>
        </li> -->
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "CustomNavbar",
  props: {
    refNameList: {
      type: Array,
      required: true,
    },
    navbarNameList: {
      type: Array,
      required: true,
    },
    refNameIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // refNameIndex: 0,
    };
  },
  methods: {
    handleLinkClick(refName, index) {
      this.$emit("scrollToSection", refName);
      // this.$emit("update:refNameIndex", this.refNameIndex);
    },
  },
};
</script>

<style lang="less" scoped>
.custom-navbar {
  background-color: #ffffff;
  border-bottom: 0.9994px solid #e0e0e0;
  width: 100%;
  height: 1.1067rem;
  position: fixed;
  z-index: 99999;
}

.container {
  height: 100%;
  max-width: 1199.998px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.4743rem;
}

.navbar-brand {
  font-size: 0.3794rem;
  font-weight: bold;
  color: #333333;

  img {
    height: 0.8rem;
  }
}

.navbar-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
}

/* .navbar-item {
    margin-left: 19.9996px;
  } */

.navbar-link {
  font-family: "Microsoft YaHei", "微软雅黑", "MicrosoftJhengHei", "华文细黑",
    "STHeiti", "MingLiu", sans-serif;
  font-size: 0.26rem;
  font-weight: 500;
  color: #676b73;
  padding: 0.1rem;
  // padding-right: 0.07rem;
  margin-left: 0.7rem;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  -webkit-transition: color 500ms;
  -o-transition: color 500ms;
  transition: color 500ms;
  text-decoration: none;
}

.navbar-link-active {
  border-bottom: 1px solid #2c5530;
  color: #2c5530;
  font-weight: 700;
}

.navbar-link:hover {
  color: #2c5530;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue